// extracted by mini-css-extract-plugin
module.exports = {"banner":"announcement-banner_banner__8HDXX"};